<div>
  <div class="gb-dialog-header">
    <h1 translate="PROJECTOR.ADD_PROJECTOR_TEMPLATE"></h1>

    <button mat-icon-button type="button" mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content">
    <gb-presenter-template-config></gb-presenter-template-config>
  </div>

  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button (click)="confirm()" mat-flat-button>
      <span translate="CREATE"></span>
    </button>
  </div>
</div>
